var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingInformation = function SvgBillingInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#billing-information_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21H3.833a1.417 1.417 0 0 1-1.416-1.417l.08-16.166A1.417 1.417 0 0 1 3.912 2H18.08a1.417 1.417 0 0 1 1.416 1.417V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7V6h6v1M8.5 11.43V6M14.5 6h2M14.5 11h2M5.5 16h8M16.625 22.376l6.357-6.359a1.763 1.763 0 0 0 .003-2.493l-.007-.007a1.76 1.76 0 0 0-2.493 0l-6.36 6.36-.625 3.125z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "billing-information_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgBillingInformation;